import { render, staticRenderFns } from "./Print.vue?vue&type=template&id=6c010c2e&"
import script from "./Print.vue?vue&type=script&lang=ts&"
export * from "./Print.vue?vue&type=script&lang=ts&"
import style0 from "./Print.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports